import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import PaginateSelect from '../field_group/PaginateSelect';

import { searchEnvelopByText } from '../../redux/envelop/envelop_actions';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';

export class SectionDetail extends React.Component {
  constructor(props) {
    super(props);

    this.formRef = undefined;
  }

  getSectionData() {
    return this.formRef.getFormData();
  }

  render() {
    const {
      name,
      envelop_id,
      envelop_name,
      area,
      WWR,
      description,
    } = this.props.section || {};

    const { listEnvelop, isShowArea, isShowWWR, t, disabled, fieldErrors, ...otherAttr } = this.props;
    const customAttr = { disabled };

    const envelopOptions = envelop_id ? [{ value: envelop_id, label: envelop_name }] : [];

    return (
      <Form
        {...otherAttr}
        showThumbnail={false}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
        ref={ref => (this.formRef = ref)}
      >
        <FieldGroup
          id="section-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="section-envelop"
          field="envelop_id"
          componentClass={PaginateSelect.TYPE_NAME}
          label={t('envelop')}
          value={envelop_id}
          loadOptions={listEnvelop}
          options={envelopOptions}
        />
        {isShowArea && (<FieldGroup
            id="section-area"
            field="area"
            type="number"
            label={`${t('area')} (${t('sq m')})`}
            placeholder="1000"
            value={area}
            errorMessage={getErrorValue(fieldErrors, 'area')}
            {...customAttr}
            disabled={true}
          />)
        }
        {isShowWWR && (<FieldGroup
            id="section-WWR"
            field="WWR"
            type="number"
            label={t('WWR')}
            placeholder="1000"
            value={WWR}
            errorMessage={getErrorValue(fieldErrors, 'WWR')}
            {...customAttr}
            disabled={true}
          />)
        }
        <FieldGroup
          id="section-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

SectionDetail.defaultProps = {
  isShowArea: false,
  isShowWWR: false,
};

const mapPropsToState = (dispatch, { building }) => ({
  listEnvelop: (searchValue, prevOptions) => {
    const page = Math.floor(prevOptions.length / 10);
    return searchEnvelopByText(searchValue, building.id, page)
      .then(resp => resp.data.map(option => ({value: option.id, label: option.name})))
  },
});

export default translate('translations', { withRef: true })(
  connect(
    null,
    mapPropsToState,
    null,
    { withRef: true },
  )(SectionDetail),
);



// WEBPACK FOOTER //
// ./src/components/section/SectionDetail.js